import React, { useState } from 'react';
import { useEnquiryStore } from '../store/useEnquiryStore';
import { FormNavigation } from './FormNavigation';
import { EnquiryList } from './EnquiryList';
import { CustomerDetailsForm } from './forms/CustomerDetailsForm';
import { AppointmentDetailsForm } from './forms/AppointmentDetailsForm';
import { QuoteDetailsForm } from './forms/QuoteDetailsForm';
import { OutcomeForm } from './forms/OutcomeForm';
import { SpecificationsForm } from './forms/SpecificationsForm';
import { AttachmentsForm } from './forms/AttachmentsForm';
import { ReviewForm } from './forms/ReviewForm';

export const FormContainer: React.FC = () => {
  const { currentStep, setCurrentStep, isFormValid, createNewEnquiry } = useEnquiryStore();
  const [showEnquiryList, setShowEnquiryList] = useState(false);

  const renderCurrentStep = () => {
    switch (currentStep) {
      case 'customer':
        return <CustomerDetailsForm />;
      case 'appointment':
        return <AppointmentDetailsForm />;
      case 'quote':
        return <QuoteDetailsForm />;
      case 'outcome':
        return <OutcomeForm />;
      case 'specifications':
        return <SpecificationsForm />;
      case 'attachments':
        return <AttachmentsForm />;
      case 'review':
        return <ReviewForm />;
      default:
        return <CustomerDetailsForm />;
    }
  };

  const handleToggleEnquiryList = () => {
    setShowEnquiryList(!showEnquiryList);
  };

  const handleCreateNewEnquiry = () => {
    createNewEnquiry();
    setShowEnquiryList(false); // Go back to form
  };

  const handleEditEnquiry = () => {
    setShowEnquiryList(false); // Go back to form without creating new enquiry
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <FormNavigation
        currentStep={currentStep}
        onStepChange={setCurrentStep}
        isFormValid={isFormValid}
        showEnquiryList={showEnquiryList}
        onToggleEnquiryList={handleToggleEnquiryList}
        onCreateNewEnquiry={handleCreateNewEnquiry}
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {showEnquiryList ? (
          <EnquiryList onCreateNewEnquiry={handleCreateNewEnquiry} onEditEnquiry={handleEditEnquiry} />
        ) : (
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-lg shadow-sm border border-gray-200">
              {renderCurrentStep()}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};